export const TRIPADVISOR_RESORT_REVIEW = '/resort-review/resort/:resortId/reviews/languages?member=:allMemberReview';
export const TRIPADVISOR_RESORT_REVIEW_WITH_LANG = '/resort-review/resort/:resortId/reviews/:language\\?member=:member&offset=0&lang=:lang&sort=:sortKey&sortdir=-1';
export const TRIPADVISOR_REVIEW_SUMMARY = '/resort-review/resorts/:resortId\\?subratings=:subratings&lang=:languageCode';
export const TRIPADVISOR_RESORT_REVIEW_DATA = '/resort-review/resorts/:resortId/reviews/:language/aggregatedreview';
export const AI_FEE_CALCULATE = '/aifee/calculate';
export const MEMBER_PROFILE_SERVICE = '/customer';
export const AU_BOOK_NOW = '/weeks-order/:productType/:operationType';
export const UNIT_TYPES = '/:resortId/unit-types';
export const RESORT_DETAILS = '/rci/resorts/details';
export const RESORT_UNIT_DETAILS = '/rci/resorts/:resortIds/unit-details';
export const ADDITIONAL_DETAILS = '/rci/resorts/:resortId/additional-details';
export const PRICED_UNIT_DETAILS = '/:resortId/priced-unit-details';
export const VACATION_TYPE = '/rci/resorts/:resortId/vacation-types';
export const VIEW_ALL_RESORTS = '/weeks-search/ALL/list-view?newSearch=true&track1=Navigation_Weeks_Header&track2=Book&track3=Text:All_Vacations';
export const MESSAGE_CATALOG_URL = '/utilities/message-translations/retrieval';
export const MEMBER_ELIGIBILITY = '/members/:leadId/eligibility/features';
export const RESORT_VIDEO_GALLERY = '/rci/resorts/video-details';
export const RESORT_ASSETS_PATH = '/Resorts/Assets';
export const GOOGLE_CLIENT_ID = 'gme-rci';
export const UNIT_DETAILS = '/:resortId/unit-details';
export const AU_SERVICE_URL = '/rci/available-units';
export const RESORT_IMAGES_URL = '/rci/resorts';
export const AU_OGS_URL = '/ongoing-search/weeks/create';
export const REFRESH_TOKEN_URL = '/refresh-token';
export const TP_BALANCE = '/rcio/:customerId/ownerships/exchangeandtradingpowercount';
export const AGGREGATED_RESORTS_URL = "/rci/resorts/:resortId/aggregatedResorts";
export const ASPOT_CONFIG = '/content/dam/panorama/cmp-json/nba-config/WOW-ASPotConfig.json';
// export const UNIT_TYPES_NEW = '/v2/:resortId/unit-types';
export const UNIT_TYPES_NEW = '/unit-types';
export const PRICED_UNIT_DETAILS_NEW = '/available-units/v2/:resortId/priced-unit-details';
export const UNIT_DETAILS_NEW = '/v2/:resortId/unit-details';
export const AU_SERVICE_URL_NEW = '/available-units';
